import { render, staticRenderFns } from "./Table2.vue?vue&type=template&id=581e1d62&scoped=true&"
import script from "./Table2.vue?vue&type=script&lang=js&"
export * from "./Table2.vue?vue&type=script&lang=js&"
import style0 from "./Table2.vue?vue&type=style&index=0&id=581e1d62&scoped=true&lang=css&"
import style1 from "./Table2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e1d62",
  null
  
)

export default component.exports